import React, { Component } from 'react'
import {
  extendParentClass,
  extendBaseClass,
  extend,
  getClassWithVariant,
} from '../../../../utils/classes'

export class Button extends Component {
  baseClass = extendParentClass.bind(this)('button')

  extend = extendBaseClass.bind(this)

  handleClick = () => {
    const { index, setSlide } = this.props
    setSlide(index)
  }

  getClassName = () => {
    const { index, slide } = this.props
    const isSelected = index === slide
    if (isSelected) {
      return getClassWithVariant('selected', this.baseClass)
    }
    return this.baseClass
  }

  render() {
    const { Icon, children } = this.props
    const iconClass = this.extend('icon')
    return (
      <button className={this.getClassName()} onClick={this.handleClick}>
        <div className={iconClass}>
          <Icon className={extend(iconClass, 'svg')} />
        </div>
        <span>{children}</span>
      </button>
    )
  }
}

export default Button
